export default {
    categories: state => state.categories,
    selectedCategoryId: state => state.selectedCategoryId,
    specialists: state => state.specialists,
    specialistsLoading: state => state.specialistsLoading,

    selectedCategory: (state) => {
        return state.categories.find(category => category.id ===  state.selectedCategoryId)
    }
}
